/**
 * Kontensalden / Kontenblatt: host sometimes omits fromDate (or toDate) on GET
 * .../postings/accounts, which yields an open-ended range. Patch the request using the page URL
 * or lux_rangeInput_memory (date lock).
 *
 * Inner fetch layer below luxFetchDispatcher. Loads last in features/ (zz*), so luxNativeFetch passes through
 * Kontensalden → invoice emoji → P&L → attendance → browser fetch.
 */
;(function luxKontensaldenPostingsFetchPatch() {
  const innerFetch = window.fetch

  function luxPostingQueryDateToIso(s) {
    if (!s || typeof s !== 'string') return null
    const t = s.trim()
    if (/^\d{4}-\d{2}-\d{2}/.test(t)) return t.slice(0, 10)
    const m = t.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/)
    if (!m) return null
    return `${m[3]}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}`
  }

  function luxIsAccountBalancesDetailPath() {
    const path = window.location.pathname || ''
    return /^\/account-balances\/[^/]+\/account\/[^/]+$/.test(path) ||
      /^\/dashboard\/account-sheet\/property\/[^/]+\/account\/[^/]+$/.test(path)
  }

  function luxGetPostingDateFallbackFromPageOrLock() {
    try {
      let lockStart = null
      let lockEnd = null
      const raw = localStorage.getItem('lux_rangeInput_memory')
      if (raw) {
        const parsed = JSON.parse(raw)
        if (parsed && typeof parsed.startDate === 'string' && typeof parsed.endDate === 'string') {
          lockStart = luxPostingQueryDateToIso(parsed.startDate)
          lockEnd = luxPostingQueryDateToIso(parsed.endDate)
        }
      }

      if (luxIsAccountBalancesDetailPath() && lockStart && lockEnd) {
        return { startIso: lockStart, endIso: lockEnd }
      }

      const pageSp = new URL(window.location.href).searchParams
      const pageStart = luxPostingQueryDateToIso(pageSp.get('startDate') || '')
      const pageEnd = luxPostingQueryDateToIso(pageSp.get('endDate') || '')
      const startIso = pageStart || lockStart
      const endIso = pageEnd || lockEnd
      if (startIso || endIso) return { startIso, endIso }
    } catch (_e) {
      /* ignore */
    }
    return null
  }

  function luxTryPatchPostingsAccountsFetchUrl(urlInput, options) {
    try {
      const method = (options && options.method) ||
        (typeof Request !== 'undefined' && urlInput instanceof Request ? urlInput.method : 'GET') ||
        'GET'
      const m = String(method).toUpperCase()
      if (m !== 'GET' && m !== '') return null

      const urlStr = typeof urlInput === 'string' ? urlInput : (urlInput && urlInput.url) || ''
      if (!urlStr.includes('postings/accounts')) return null

      let u
      try {
        u = new URL(urlStr, window.location.origin)
      } catch (_e) {
        return null
      }
      if (!u.pathname.includes('/services/pmp-accounting/api/v1/postings/accounts')) return null

      const fromRaw = u.searchParams.get('fromDate')
      const toRaw = u.searchParams.get('toDate')
      const hasFrom = fromRaw != null && String(fromRaw).trim() !== ''
      const hasTo = toRaw != null && String(toRaw).trim() !== ''
      if (hasFrom && hasTo) return null

      const fallbacks = luxGetPostingDateFallbackFromPageOrLock()
      if (!fallbacks) return null

      let changed = false
      if (!hasFrom && fallbacks.startIso) {
        u.searchParams.set('fromDate', fallbacks.startIso)
        changed = true
      }
      if (!hasTo && fallbacks.endIso) {
        u.searchParams.set('toDate', fallbacks.endIso)
        changed = true
      }
      if (!changed) return null

      const pathAndQuery = u.pathname + u.search + u.hash

      if (typeof urlInput === 'string') {
        if (/^https?:\/\//i.test(urlInput)) return u.toString()
        return pathAndQuery
      }
      if (typeof Request !== 'undefined' && urlInput instanceof Request) {
        return new Request(pathAndQuery, {
          method: urlInput.method,
          headers: urlInput.headers,
          mode: urlInput.mode,
          credentials: urlInput.credentials,
          cache: urlInput.cache,
          redirect: urlInput.redirect,
          referrer: urlInput.referrer,
          referrerPolicy: urlInput.referrerPolicy,
          integrity: urlInput.integrity,
          keepalive: urlInput.keepalive,
          signal: urlInput.signal,
        })
      }
    } catch (_e) {
      /* ignore */
    }
    return null
  }

  window.fetch = async function (url, options) {
    const urlString = typeof url === 'string' ? url : url.url || url.toString()
    let fetchInput = url
    if (urlString.includes('postings/accounts')) {
      const opts = options === undefined ? {} : options
      const patched = luxTryPatchPostingsAccountsFetchUrl(url, opts)
      if (patched != null) {
        fetchInput = patched
      }
    }

    if (fetchInput === url) {
      return innerFetch.apply(this, arguments)
    }
    return typeof url === 'string'
      ? await innerFetch(fetchInput, options === undefined ? {} : options)
      : await innerFetch(fetchInput)
  }
})()
